import React from 'react';
import { useTranslations } from '@unisporkal/localization';
import {
  Typography,
  TypographyComponentEnum,
  TypographyVariant,
} from '@unisporkal/alliance-ui';
import styles from './ModifiedLicenseMessage.module.scss';

const ModifiedLicenseMessage = () => {
  const t = useTranslations();

  return (
    <section data-testid="modified-license-message-container">
      <Typography
        className={styles.message}
        component={TypographyComponentEnum.P}
        variant={TypographyVariant.body.small}
      >
        {t('need_royalty_license_to_download')}
      </Typography>
    </section>
  );
};

export default ModifiedLicenseMessage;
